import Raven from 'raven-js';
import { currentOrderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { FullProductLineMap } from 'self-service-api/constants/ProductLineMap';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
export const getHighlightsForProductLine = productLine => {
  const {
    highlightedFreeProduct,
    highlightedProducts
  } = FullProductLineMap[productLine];
  return [...(highlightedFreeProduct ? [highlightedFreeProduct] : []), ...highlightedProducts];
};
export const getAllFreeProducts = () => {
  const productLines = Object.keys(FullProductLineMap);
  return productLines.map(productLine => {
    return FullProductLineMap[productLine].highlightedFreeProduct || null;
  });
};
export const getProductLevelFromApiNameString = apiName => {
  const segments = apiName.split('-');
  const productLevel = segments.find(item => {
    return currentOrderedProductLevels.includes(item.toUpperCase());
  });
  if (!productLevel) {
    const error = new Error('Failed to find productLevel from apiName');
    Raven.captureException(error, {
      extra: {
        apiName
      }
    });
    throw error;
  }
  return productLevel.toUpperCase();
};
export const getProductLineFromApiNameString = apiName => {
  const segments = apiName.split('-');
  const productLine = segments.find(segment => AllProductLines.includes(segment.toUpperCase()));
  if (!productLine) {
    const error = new Error('Failed to find productLine from apiName');
    Raven.captureException(error, {
      extra: {
        apiName
      }
    });
    throw error;
  }
  return productLine.toUpperCase();
};
export const buildFilteredHighlightedProducts = ({
  productLine,
  productLevels
}) => {
  const highlightedProducts = getHighlightsForProductLine(productLine);
  return highlightedProducts.filter(apiName => {
    const localProductLevel = getProductLevelFromApiNameString(apiName);
    return productLevels.includes(localProductLevel);
  });
};